// extracted by mini-css-extract-plugin
export default {"counterBox":"Counter_counterBox__B62PL","title":"Counter_title__448pa","prefix":"Counter_prefix__NXEwE","number":"Counter_number__Mbq-F"};